import { createApp } from 'vue';
import Toaster from '@meforma/vue-toaster';
import VueGtag from 'vue-gtag';
import { VueCookieNext } from 'vue-cookie-next';
import KonamiCode from 'vue-konami-code';

import 'devextreme/dist/css/dx.light.css';
import '@/scss/main.scss';

import i18n from './i18n/i18n';
import App from './App.vue';

import registerGlobalComponents from './plugins/components';

import router from './router';
import store from './store';

const app = createApp(App);

app.use(i18n);
app.use(store);
app.use(router);
app.use(VueCookieNext);
app.use(VueGtag, {
    config: {
        id: process.env.VUE_APP_GA4,
        params: {
            anonymize_ip: true,
        },
    },
    router,
    enabled: false,
});
app.use(Toaster, {
    position: 'bottom-left',
    maxToasts: 2,
}).provide('toast', app.config.globalProperties.$toast);
app.use(KonamiCode, {
    callback: function () {
        window.location.href = 'https://youtu.be/dQw4w9WgXcQ';
    },
});

registerGlobalComponents(app);

// Will be used later
app.provide('gtag', app.config.globalProperties.$gtag);

app.mount('#app');

document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
});
